angular.module('core')
    .controller('VerifyAssignmentModalController', ['$scope', '$modalInstance', 'activeAssignments', function($scope, $modalInstance, $activeAssignments) {

        $scope.activeAssignments = $activeAssignments;

        // @INFO: Helpful info on how angular modals should work
        // http://stackoverflow.com/questions/19743299/what-is-the-difference-between-dismiss-a-modal-and-close-a-modal-in-angular
        // http://plnkr.co/edit/xMTr78WJQbKyHsA53gyv?p=preview
        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function() {
            $modalInstance.dismiss('canceled by user');
        };
    }]);
